import { defineComponent as we, useSlots as xe, defineAsyncComponent as J, computed as s, useAttrs as pe, ref as B, openBlock as n, createElementBlock as d, normalizeClass as L, createVNode as R, unref as g, createSlots as U, withCtx as h, withDirectives as T, createBlock as C, resolveDynamicComponent as Le, mergeProps as j, createElementVNode as Ce, toDisplayString as v, Fragment as S, renderList as E, createCommentVNode as w, createTextVNode as P, Suspense as Se, renderSlot as $e, vShow as De, nextTick as Ve } from "vue";
import { RevPopover as Ie } from "@ds/components/Popover";
import { usePropsValidation as Be } from "../../composables/usePropsValidation.js";
import { vFocus as Q } from "../../directives/focus.js";
import Te from "../../icons/generated/IconWarning.vue2.js";
import { isEmpty as f } from "../../utils/isEmpty.js";
import { isEqual as W } from "../../utils/isEqual.js";
import { omit as Ee } from "../../utils/omit.js";
import { tw as r } from "../../utils/tailwind.js";
import { VariantsEnum as X } from "./InputSelect.constant.js";
import { componentHasFocus as Pe } from "./InputSelect.helpers.js";
import qe from "./components/InputSelectButton.vue2.js";
import Fe from "./components/InputSmallSelectButton.vue2.js";
const Ne = ["id", "aria-label", "disabled", "hidden", "required", "value"], Ae = ["id", "selected"], Oe = ["disabled", "label"], ze = ["disabled", "selected", "value"], Ke = ["disabled", "selected", "value"], Me = ["id", "role"], tt = /* @__PURE__ */ we({
  name: "RevInputSelect",
  inheritAttrs: !1,
  __name: "InputSelect",
  props: {
    autofocus: { type: Boolean, default: !1 },
    description: { default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    error: { default: () => {
    } },
    id: {},
    customListId: { default: "" },
    label: {},
    options: {},
    modelValue: {},
    size: { default: "medium" },
    variant: { default: () => X.Floating },
    required: { type: Boolean, default: !1 }
  },
  emits: ["change", "update:modelValue"],
  setup(t, { emit: Y }) {
    const q = xe(), $ = Y, Z = J(
      () => import("../List/List.vue.js")
    ), _ = J(
      () => import("./components/InputSelectItem.vue.js")
    ), ee = s(() => Ee(pe(), ["class"])), b = s(
      () => !!q.optionPrefix || !!t.customListId
    );
    Be({
      "If you choose to use a custom list, the `customListId` is required": () => !!q.optionPrefix && !t.customListId
    });
    const x = (e, l, a = "") => {
      const i = typeof e == "string" ? {
        disabled: !1,
        label: e,
        value: e
      } : e;
      return {
        key: `${f(a) ? "" : `${a}/`}${i.label}-${l}`,
        ...i
      };
    }, F = B(null), c = s(() => t.size === "small"), N = s(() => t.variant === X.Fixed), D = B(!1), A = () => {
      D.value = !1;
    }, O = () => {
      D.value = !0;
    }, te = () => {
      F.value?.focus();
    }, z = s(() => t.options.some(
      (e) => JSON.stringify(e).includes(JSON.stringify(t.modelValue))
    )), le = s(
      () => c.value ? `${t.id}-label-option` : void 0
    ), ae = s(() => c.value ? t.label : void 0), oe = s(() => f(t.options) ? [] : t.options.filter((e) => {
      const { group: l, options: a } = e;
      return l && !f(a);
    }).reduce((e, l) => {
      const a = l, i = `${a.label}-${t.options.indexOf(l)}`;
      return [
        ...e,
        {
          disabled: a.disabled,
          key: i,
          label: a.label,
          options: a.options.map(
            (u, o) => x(u, o, i)
          )
        }
      ];
    }, [])), K = s(() => f(t.options) ? [] : t.options.filter((e) => !e.group).reduce((e, l) => [...e, x(l, t.options.indexOf(l))], [])), V = s(() => [
      ...K.value,
      ...oe.value.reduce(
        (e, { options: l }) => [
          ...e,
          ...l
        ],
        []
      )
    ]), se = s(() => f(t.options) ? [] : t.options.map((e, l) => {
      if (e.group) {
        const a = e, i = `${a.label}-${l}`;
        return {
          disabled: a.disabled,
          key: i,
          label: a.label,
          options: a.options.map(
            (u, o) => x(u, o, i)
          )
        };
      }
      return x(e, l);
    })), ie = (e) => e.options !== void 0, ue = s(
      () => c.value ? Fe : qe
    ), y = s(() => !f(t.error)), M = s(() => y.value ? t.error : t.description), re = s(() => {
      if (y.value)
        return y.value && `${t.id}_error`;
    }), ne = (e) => {
      $("change", e);
      const l = V.value.find(
        ({ key: a }) => a === e.target.value
      );
      l !== void 0 && !f(l) && $("update:modelValue", l.value);
    }, G = (e) => {
      $("update:modelValue", e.value);
    }, k = s(() => {
      const e = V.value.find(
        ({ value: l }) => W(t.modelValue, l)
      );
      return e !== void 0 && !f(e) ? e.key : null;
    }), p = B([]), de = async (e, l, a) => {
      if (Pe(e)) {
        if (await Ve(), k.value === l.key) {
          e.focus();
          return;
        }
        !k.value && a === 0 && e.focus();
      }
    };
    function ce({
      isOpen: e,
      hide: l,
      show: a
    }) {
      return e ? l() : a();
    }
    const fe = (e, {
      isOpen: l,
      hide: a,
      show: i
    }) => {
      e.key === "Enter" || e.key === " " || e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), l || i()) : e.key === "Escape" && l && (e.preventDefault(), e.stopPropagation(), a());
    }, me = (e, l, a, i) => {
      e.key === "ArrowDown" ? (e.preventDefault(), p.value[l + 1]?.focus()) : e.key === "ArrowUp" ? (e.preventDefault(), p.value[l - 1]?.focus()) : e.key === "Enter" ? (e.preventDefault(), G(a), i()) : e.key === "Escape" && (e.preventDefault(), i());
    }, ve = s(
      () => !c.value && !f(M.value)
    ), I = s(() => {
      const e = V.value.find(
        ({ value: l }) => W(t.modelValue, l)
      );
      return e !== void 0 && !f(e) ? e.label : null;
    }), be = s(() => t.disabled ? r`text-static-default-low-disabled` : c.value && y.value ? r`text-action-danger-hi` : r`text-action-default-hi`), ye = s(() => [
      r`block w-full cursor-pointer truncate pl-12`,
      c.value ? r`body-2-bold w-full pr-40` : r`body-1 pt-20`,
      be.value,
      N.value && r`flex h-[2.375rem] items-center !pt-0`
    ]), ke = r`body-2-bold w-full cursor-pointer pl-12 pr-40`, H = s(() => c.value ? t.label : ""), he = s(() => [
      r`body-2 mt-8`,
      r`flex items-center`,
      t.disabled && r`text-static-default-low-disabled`,
      !t.disabled && t.error && r`text-static-danger-hi`,
      !t.disabled && !t.error && r`text-static-default-low`
    ]), ge = s(() => {
      const e = r`rounded-sm w-full cursor-pointer appearance-none truncate border-0 bg-transparent pl-12 text-inherit outline-none disabled:text-action-default-hi-disabled disabled:cursor-not-allowed`;
      return c.value ? [e, r`body-1-bold h-full pr-40`] : N.value ? [e, r`body-1 h-[2.375rem] pr-32`] : [e, r`body-1 pr-32 pt-20`];
    });
    return (e, l) => (n(), d("div", {
      class: L(["relative", e.$attrs.class])
    }, [
      R(g(Ie), {
        "content-class-names": "z-10 w-full",
        position: "bottom-start"
      }, U({
        trigger: h(({ hide: a, isOpen: i, show: u }) => [
          T((n(), C(Le(ue.value), j({
            ...b.value ? {
              "aria-expanded": i,
              "aria-controls": t.customListId,
              role: "combobox",
              tabindex: 0,
              onClick: () => ce({ isOpen: i, hide: a, show: u }),
              onKeydown: (o) => fe(o, { isOpen: i, hide: a, show: u }),
              onBlur: A,
              onFocus: O
            } : {
              tabindex: -1
            }
          }, {
            disabled: t.disabled,
            focused: D.value || i,
            "has-error": y.value,
            "has-selected-option": z.value,
            required: t.required,
            "select-id": t.id,
            variant: t.variant,
            onClickLabel: te
          }), U({
            value: h(() => [
              T((n(), d("select", j({ id: t.id }, ee.value, {
                ref_key: "select",
                ref: F,
                "aria-label": ae.value,
                class: ge.value,
                disabled: t.disabled,
                hidden: b.value,
                required: t.required,
                value: k.value,
                onBlur: A,
                onChange: ne,
                onFocus: O
              }), [
                Ce("option", {
                  id: le.value,
                  "aria-hidden": "true",
                  class: "bg-action-default-low text-static-default-hi",
                  disabled: "",
                  hidden: "",
                  selected: !z.value,
                  value: ""
                }, v(H.value), 9, Ae),
                (n(!0), d(S, null, E(se.value, (o) => (n(), d(S, null, [
                  ie(o) ? (n(), d("optgroup", {
                    key: `group_${o.key}`,
                    disabled: o.disabled,
                    label: o.label
                  }, [
                    (n(!0), d(S, null, E(o.options, (m) => (n(), d("option", {
                      key: m.key,
                      class: "bg-action-default-low text-static-default-hi",
                      disabled: m.disabled,
                      selected: m.key === k.value,
                      value: m.key
                    }, v(m.label), 9, ze))), 128))
                  ], 8, Oe)) : (n(), d("option", {
                    key: o.key,
                    class: "bg-action-default-low text-static-default-hi",
                    disabled: o.disabled,
                    selected: o.key === k.value,
                    value: o.key
                  }, v(o.label), 9, Ke))
                ], 64))), 256))
              ], 16, Ne)), [
                [g(Q), t.autofocus && !b.value]
              ]),
              b.value && !I.value && c.value ? (n(), d("p", {
                key: 0,
                class: L(ke)
              }, v(H.value), 1)) : w("", !0),
              b.value && I.value ? (n(), d("output", {
                key: 1,
                class: L(ye.value)
              }, v(I.value), 3)) : w("", !0)
            ]),
            _: 2
          }, [
            c.value ? void 0 : {
              name: "label",
              fn: h(() => [
                P(v(t.label), 1)
              ]),
              key: "0"
            }
          ]), 1040, ["disabled", "focused", "has-error", "has-selected-option", "required", "select-id", "variant"])), [
            [g(Q), t.autofocus && b.value]
          ])
        ]),
        _: 2
      }, [
        b.value ? {
          name: "content",
          fn: h(({ isOpen: a, hide: i }) => [
            a ? (n(), C(Se, { key: 0 }, {
              default: h(() => [
                T(R(g(Z), {
                  id: t.customListId,
                  "aria-multiselectable": !1,
                  class: "bg-action-default-low shadow-long rounded-sm mt-4 overflow-y-auto border-t-0",
                  role: "listbox"
                }, {
                  default: h(() => [
                    (n(!0), d(S, null, E(K.value, (u, o) => (n(), C(g(_), {
                      key: o,
                      id: `${u.label}-${o}`,
                      ref_for: !0,
                      ref_key: "customListItems",
                      ref: p,
                      "is-selected": u.key === k.value,
                      "items-center": !0,
                      label: u.label,
                      option: u,
                      onKeydown: (m) => me(m, o, u, i),
                      onSelect: (m) => (G(u), i()),
                      onVnodeMounted: () => de(
                        p.value[o],
                        u,
                        o
                      )
                    }, {
                      prefix: h(() => [
                        $e(e.$slots, "optionPrefix", {
                          index: o,
                          isSelected: u.key === k.value,
                          option: u
                        }, () => [
                          l[0] || (l[0] = P(v(""), -1))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["id", "is-selected", "label", "option", "onKeydown", "onSelect", "onVnodeMounted"]))), 128))
                  ]),
                  _: 2
                }, 1032, ["id"]), [
                  [De, a && !t.disabled]
                ])
              ]),
              _: 2
            }, 1024)) : w("", !0)
          ]),
          key: "0"
        } : void 0
      ]), 1024),
      ve.value ? (n(), d("p", {
        key: 0,
        id: re.value,
        "aria-live": "assertive",
        class: L(he.value),
        role: y.value ? "alert" : "presentation"
      }, [
        y.value ? (n(), C(g(Te), {
          key: 0,
          class: "mr-4",
          size: "20"
        })) : w("", !0),
        P(" " + v(M.value), 1)
      ], 10, Me)) : w("", !0)
    ], 2));
  }
});
export {
  tt as default
};
